import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "team-status" }

import { useProgramsStore } from '@/stores/programs';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamStatus',
  props: {
    stageId: null,
    date: null
  },
  setup(__props: any) {

const props = __props as { stageId?: string, date?: string }


const programsStore = useProgramsStore()

const titles = {
  "unknown": "Unknown",
  "late": "С опозданием",
  "normal": "По плану",
  "ahead": "С опережением плана"
}

const status = computed(() => {
  if (!props.stageId || !props.date) return "unknown"
  const index = programsStore.stages.findIndex(item => item.id === props.stageId)
  if (index < 0) return "unknown"
  if (props.date > programsStore.stages[index].deadline) return "late"
  if (index < programsStore.stages.length-1 && props.date > programsStore.stages[index+1].deadline) return "ahead"
  return "normal"
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["team-status-marker", _unref(status)])
    }, null, 2),
    _createTextVNode(" " + _toDisplayString(titles[_unref(status)]), 1)
  ]))
}
}

})